<div class="d-flex mb-3 justify-content-between flex-column mt-5">
  <h3 class="text-weight-600 text-primary">{{ 'auth_one_more_step_to_go' | translate }}</h3>
  <p class="mt-3">{{ 'auth_check_your_email' | translate }}</p>
</div>
